var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_awesome-linkedin-in","data-name":"Icon awesome-linkedin-in","d":"M3.613,16.14H.267V5.364H3.613ZM1.938,3.894A1.947,1.947,0,1,1,3.876,1.938,1.954,1.954,0,0,1,1.938,3.894Zm14.2,12.246H12.8V10.894c0-1.25-.025-2.853-1.74-2.853-1.74,0-2.006,1.358-2.006,2.763V16.14H5.709V5.364H8.918v1.47h.047a3.516,3.516,0,0,1,3.166-1.74c3.387,0,4.009,2.23,4.009,5.127V16.14Z","transform":"matrix(1, 0.017, -0.017, 1, 0.282, 0)","fill":"#fff"}));
}

Linkedin.defaultProps = {"width":"16.419","height":"16.419","viewBox":"0 0 16.419 16.419"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
